import Select from '@/components/Select/Select';

export default Select;
